import {
  //
  ADD_PACKAGE,
  ADD_PACKAGE_FAILURE,
  ADD_PACKAGE_SUCCESS,
  //
  DELETE_PACKAGE,
  DELETE_PACKAGE_FAILURE,
  DELETE_PACKAGE_SUCCESS,
  //
  EDIT_PACKAGE,
  EDIT_PACKAGE_FAILURE,
  EDIT_PACKAGE_SUCCESS,
  //
  FETCH_PACKAGES,
  FETCH_PACKAGES_FAILURE,
  FETCH_PACKAGES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchPackages = (payload) => ({
  type: FETCH_PACKAGES,
  payload,
});
export const fetchPackagesSuccess = (payload) => ({
  type: FETCH_PACKAGES_SUCCESS,
  payload,
});
export const fetchPackagesFailure = (payload) => ({
  type: FETCH_PACKAGES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addPackage = (payload) => ({
  type: ADD_PACKAGE,
  payload,
});
export const addPackageSuccess = (payload) => ({
  type: ADD_PACKAGE_SUCCESS,
  payload,
});
export const addPackageFailure = (payload) => ({
  type: ADD_PACKAGE_FAILURE,
  payload,
});
// EDIT
export const editPackage = (payload) => ({
  type: EDIT_PACKAGE,
  payload,
});
export const editPackageSuccess = (payload) => ({
  type: EDIT_PACKAGE_SUCCESS,
  payload,
});
export const editPackageFailure = (payload) => ({
  type: EDIT_PACKAGE_FAILURE,
  payload,
});
// DELETE
export const deletePackage = (payload) => ({
  type: DELETE_PACKAGE,
  payload,
});
export const deletePackageSuccess = (payload) => ({
  type: DELETE_PACKAGE_SUCCESS,
  payload,
});
export const deletePackageFailure = (payload) => ({
  type: DELETE_PACKAGE_FAILURE,
  payload,
});
